// extracted by mini-css-extract-plugin
export default {"icon":"IntroCard_icon__0yo1h","osIconBtn":"IntroCard_osIconBtn__FITcJ","osIconList":"IntroCard_osIconList__ddi9+","buttonContainer":"IntroCard_buttonContainer__Hyp5a"};